import { DataProvider } from 'react-admin'
import {
  DataProviderMethodResponse,
  throwNotSupported
} from '../../../dataProvider'
import { getOrgUsers, OrgUserResponse } from '../repository/getOrgUsers'
import { deleteOrgUser } from '../repository/deleteOrgUser'

const orgUsersProvider: DataProvider = {
  getList: async (_resource, params) => {
    return await getOrgUsers(params).then((response) => {
      const total = response.meta.record_count
      const data = response.data.map(parseOrgUser).filter(Boolean)

      return { data, total } as DataProviderMethodResponse
    })
  },
  getOne: throwNotSupported,
  getMany: throwNotSupported,
  getManyReference: throwNotSupported,
  update: throwNotSupported,
  updateMany: throwNotSupported,
  create: throwNotSupported,
  delete: async (_resource, params) => {
    return await deleteOrgUser(params)
  },
  deleteMany: throwNotSupported
}

const parseOrgUser = (orgUser: OrgUserResponse) => {
  if (!orgUser) return null

  return {
    id: orgUser.id,
    'User Name':
      orgUser.attributes.first_name + ' ' + orgUser.attributes.last_name,
    'User Email': orgUser.attributes.email
  }
}

export default orgUsersProvider
